export enum ConfigType {
    Css,
    Json,
    Js,
    String
}
